// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@flip/XDL/PreStyle/typography";
import { color } from "@flip/XDL/Utilities";
import { mergeWithCss } from "@flip/XDL/Utilities/mergeWithCss";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface AutoCompleteItems {
    itemWrapper?: InjectableCss;
    headerText?: TypographyPresentationProps;
    itemText?: TypographyPresentationProps;
    focusedItemText?: TypographyPresentationProps;
    link?: LinkPresentationProps;
    focusedLink?: LinkPresentationProps;
}

const sharedItemTextStyles: TypographyPresentationProps = {
    size: 12,
    weight: fontConfig.weight.regular,
    css: css`
        letter-spacing: 0;
    `,
};

const headerSearchInputStyles: AutoCompleteItems = {
    itemWrapper: {
        css: css`
            padding: 0 22px;
            margin-bottom: 12px;
            span {
                text-wrap: wrap;
            }
            &:last-child {
                margin-bottom: 0;
            }
        `,
    },
    headerText: {
        variant: "h6",
        weight: "bold",
        css: css`
            padding: 16px 22px 14px 22px;
            margin: 0;
        `,
    },
    itemText: {
        ...sharedItemTextStyles,
    },
    focusedItemText: {
        ...mergeWithCss(sharedItemTextStyles, {
            weight: "bold",
            css: css`
                background-color: ${color("common.ui2")};
            `,
        }),
    },
    link: {
        typographyProps: {
            ...sharedItemTextStyles,
        },
    },
    focusedLink: {
        color: "text.main",
        typographyProps: {
            ...mergeWithCss(sharedItemTextStyles, {
                weight: "bold",
            }),
        },
        css: css`
            background-color: ${color("common.ui2")};
        `,
    },
};

export default headerSearchInputStyles;
